export default __webpack_public_path__ + "static/ToolsOfTheTrade-5174c06cb90eab9b34145dd72d134dfc.png";